
    import './styles.scoped.css';
    export default {
  "badge": "awsui_badge_1yjyg_18p4b_93",
  "badge-color-grey": "awsui_badge-color-grey_1yjyg_18p4b_111",
  "badge-color-green": "awsui_badge-color-green_1yjyg_18p4b_114",
  "badge-color-blue": "awsui_badge-color-blue_1yjyg_18p4b_117",
  "badge-color-red": "awsui_badge-color-red_1yjyg_18p4b_120"
};
  